import React from 'react';
import styles from './Legal.module.css';

const Privacy: React.FC = () => {
  return (
    <div className={styles.legalContainer}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date: January 1, 2025</strong></p>

      <p>Welcome to "hangjam", a chat, games, and music platform accessible at hangjam.ai. This privacy policy is designed to inform you about how we collect, use, and safeguard the information you provide while using "hangjam". By accessing and using our platform, you agree to the collection and use of your information in accordance with this policy.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Platform Data:</strong> We collect data related to your activities, such as your chat messages, gameplay data, music preferences, and overall platform usage.</li>
        <li><strong>Technical Data:</strong> We may collect technical details about the device you use, such as your IP address, device type, operating system, and browser type.</li>
        <li><strong>Cookies and Similar Technologies:</strong> We use cookies to enhance your experience by remembering your preferences and tracking your activities within the game.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li><strong>Google User Data:</strong> If you choose to sign in with Google, we access and collect your email address and name as optionally provided. This information is used to create and manage your user profile within the game.</li>
        <li><strong>To Provide and Manage the Platform:</strong> We use the information we collect to deliver and improve our services, manage user accounts, and provide customer support.</li>
        <li><strong>To Enhance User Experience:</strong> We analyze gameplay data and technical information to understand user behavior and improve our game.</li>
        <li><strong>To Communicate with You:</strong> We may use your information to communicate with you about game updates, technical notices, and security alerts.</li>
      </ul>

      <h2>3. Sharing of Your Information</h2>
      <p>We do not sell or rent your personal data to third parties. However, we may share your information with:</p>
      <ul>
        <li><strong>Service Providers:</strong> Entities that perform services on our behalf, including hosting, data analysis, and technical support.</li>
        <li><strong>Legal Requirements:</strong> We may disclose your information if required by law or if we believe in good faith that such action is necessary to comply with legal processes, respond to claims, or protect the rights, property, or safety of our company or others.</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We implement reasonable security measures to protect your information from unauthorized access, alteration, or destruction. However, no security system is impenetrable, and we cannot guarantee the absolute security of your information.</p>

      <h2>5. Changes to This Privacy Policy</h2>
      <p>We may update this privacy policy from time to time. Any changes will be posted on this page, and we encourage you to review our policy periodically to stay informed about how we protect your information.</p>

      <h2>6. Contact Us</h2>
      <p>If you have any questions about this privacy policy or our handling of your information, please contact us.</p>
    </div>
  );
};

export default Privacy; 